<template>
  <section class="flex align-middle justify-center sm:py-40">
    <Card class="w-full max-w-448 p-24">
      <h1 class="text-h1 mb-16">Upgrade request sent</h1>
      <template v-if="automatedCorporateUpgradesEnabled">
        <p class="pb-16 text-body text-grey-body">
          Our Customer Success team will validate your request. You will receive a confirmation email in 1–2 business days. During
          this period, you can browse but won't be able to connect with sitters.
        </p>
        <p class="pb-16 text-body text-grey-body">
          If you have an urgent care need, please reach out to us now by
          <button class="underline" @click="openChat">chat</button> or email
          <a href="mailto:support@sittercity.com" class="underline">support@sittercity.com</a>
          and let us know!
        </p>
      </template>
      <p v-else class="pb-16 text-body text-grey-body">
        Our Customer Success team will validate your request. You will receive a confirmation email in 1-2 business days.
      </p>
      <Button class="w-full" variant="primary" value="Continue" size="medium" to="/account/seekers/dashboard" />
    </Card>
  </section>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import Button from '@/components/button/Button.vue';
import { isOn } from '@/lib/growthbook';

export default {
  name: 'UpgradeRequestSent',
  components: {
    Card,
    Button,
  },
  computed: {
    automatedCorporateUpgradesEnabled(): boolean {
      return isOn('sc-automate-corporate-upgrades-enabled');
    },
  },
  methods: {
    openChat() {
      (window as any).zE?.('messenger', 'open');
    },
  },
};
</script>
